/* tslint:disable */
 
import { ActionInfo } from './action-info';
import { DataEntryFullTextSearch } from './data-entry-full-text-search';
import { Permission } from './permission';
import { ReferenceProperty } from './reference-property';
import { ReportEntryValue } from './report-entry-value';
import { StateHistory } from './state-history';

/**
 * (tsType: Omit<ReportEntryDto, >, schemaOptions: { includeRelations: undefined, exclude: [] })
 */
export class ReportEntryDto {
  basedOn?: Array<ReferenceProperty>;
  creationInfo?: ActionInfo;
  dataEntity: string;
  entityVersion?: number;
  entryType?: 0 | 1;
  id?: string;

  /**
   * The reason why the entry is invalid
   */
  invalidReason?: 0 | 1;
  isImplicit?: boolean;

  /**
   * Whether the entry is invalid or not
   */
  isInvalid: boolean;
  lifeCycleStatus?: -1 | 0 | 1;
  permissions?: Array<Permission>;
  searchIndex?: DataEntryFullTextSearch;
  specificationVersion: number;
  state: 0 | 1 | 2;
  stateHistory?: Array<StateHistory>;
  store?: ReferenceProperty;
  updateInfo?: ActionInfo;
  value: ReportEntryValue;
  virtual?: boolean;
}
